import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicHeader from './PublicHeader'; // Import the new Header component
import PublicFooter from './PublicFooter'; // Import the new Footer component

// The Layout component is now purely for structure.
export default function PublicLayout() {
  return (
    <div>
      <PublicHeader />
      <main>
        <Outlet /> {/* This renders the specific page content */}
      </main>
      <PublicFooter />
    </div>
  );
}